import React, { useState, useEffect } from 'react';
import '../styles/About.css';

// Images Import (Aapke folder se)
import img1 from './first.jpeg';
import img2 from './second.jpeg';
import img3 from './third.jpeg';
import img4 from './fourth.jpeg';

const images = [img1, img2, img3, img4];

const About = () => {
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
        }, 3500); 
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="about-section" id="about">
            <div className="container">
                {/* Heading: About (White) Me (Blue) with Underline */}
                <div className="about-header-main">
                    <h2 className="about-title">About <span className="highlight-blue">Me</span></h2>
                  
                </div>

                <div className="about-grid">
                    {/* Left: Simple Fade Image Slider */}
                    <div className="about-image-wrapper">
                        <div className="image-container-frame">
                            {images.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt="Hina Akbar"
                                    className={`simple-fade-img ${index === currentImage ? 'active' : ''}`}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="about-text-wrapper">
                        <p className="about-description">
                            I began my journey during my BSCS degree, starting with <strong>Graphic Design</strong> and 
                            <strong> Web Designing</strong>. This creative background helped me understand user 
                            experience deeply.
                        </p>
                        
                        <p className="about-description">
                            As my fascination with technology grew, I transitioned into <strong>Full-Stack Development</strong>. 
                            I build scalable applications using the <strong>MERN Stack</strong>, 
                            converting complex Figma designs into responsive realities.
                        </p>

                        <p className="about-description">
                            Currently, I am working on an <strong>AI-based Final Year Project</strong>, 
                            integrating modern AI solutions with web technologies to solve 
                            real-world problems.
                        </p>

                        {/* Modern Achievement Row */}
                        <div className="stats-row-simple">
                            <div className="stat-item">
                                <span className="stat-count">20+</span>
                                <span className="stat-text">Projects</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-count">MERN</span>
                                <span className="stat-text">Stack</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;